import { eNotificationActionsObj } from "../../action-types/nofitication/INofiticationActionTypes";
import { generateActions } from "../generateActions";

export const nofiticationActions = {
  ...generateActions(eNotificationActionsObj, "NOFITICATION"),
};
